import axios from 'axios';
import { jwtSessionLogger } from '@enterprise/common';

export async function refreshAccessToken() {
  try {
    const response = await axios.post('/api/auth/refresh');
    if (response.status < 200 || response.status > 299) {
      throw new Error(`Access token refresh endpoint throws an unexpected code: "${response.status}"`);
    }
    jwtSessionLogger.set();
    return response.data;
  } catch (e) {
    jwtSessionLogger.clear();
    throw new Error('Unable to refresh access token.');
  }
}
